import React from 'react';
import { makeStyles } from 'tss-react/mui';

interface StyleProps {
  width: number;
}

const useStyles = makeStyles<StyleProps>()((theme, props) => ({
  root: {
    margin: 'auto',
    width: props.width,
    [theme.breakpoints.only('xs')]: {
      width: '100%!important',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
}));

interface OnboardingFormLayoutProps {
  width?: number;
  children?: React.ReactNode;
}

const OnboardingFormLayout: React.FC<OnboardingFormLayoutProps> = ({
  width = 460,
  children,
}) => {
  const { classes } = useStyles({ width });

  return <div className={classes.root}>{children}</div>;
};

export default OnboardingFormLayout;
